import { useEffect } from 'react';

import RoundedTriangle from 'public/rounded_triangle.svg';
import { Typography } from 'src/app/components/Elements/Typography';
import { IS_MOBILE } from 'src/consts';

import { ArrowIcon } from '../styles';

import { ClickOverlay, NewArchivedMedicationPageContainer, NewArchivedPageBaseModal, ShadowOverlay } from './styles';

interface ModalBackgroundInterface {
  handleModalClose: () => void;
  isActive: boolean;
}

const ModalBackground = ({ handleModalClose, isActive }: ModalBackgroundInterface) => {
  return (
    <>
      <ClickOverlay
        onClick={e => {
          // Both of these are needed to stop unwanted onClick events from the parent component such as clicking in the
          // shadow would active the Essentials tab, but it should stay within Prescriptions.
          e.preventDefault();
          e.stopPropagation();
          handleModalClose();
        }}
        isActive={isActive}
      />
      <ShadowOverlay isActive={isActive} />
    </>
  );
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

interface NewArchivedMedicationPageModalProps {
  handleModalClose: () => void;
  isActive: boolean;
}

export const NewArchivedMedicationPageModal = ({ handleModalClose, isActive }: NewArchivedMedicationPageModalProps) => {
  useEffect(() => {
    if (isActive && !IS_MOBILE) {
      scrollToTop();
    }
  }, [isActive]);

  return (
    <>
      {isActive && <ArrowIcon src={RoundedTriangle} raw />}
      <NewArchivedPageBaseModal handleModalClose={handleModalClose} isActive={isActive} showExitIcon={false}>
        <NewArchivedMedicationPageContainer>
          <Typography variant={'body'}>View archived medications here</Typography>
        </NewArchivedMedicationPageContainer>
      </NewArchivedPageBaseModal>
      <ModalBackground handleModalClose={handleModalClose} isActive={isActive} />
    </>
  );
};
